import { defineMessages } from 'react-intl'

const scope = 'app.components.MapLegends'

export default defineMessages({
  legends: {
    physical: {
      id: `${scope}.legends.physical`,
      defaultMessage: 'Physical',
    },
    employees: {
      id: `${scope}.legends.employees`,
      defaultMessage: 'Employees',
    },
    onlineMarketing: {
      id: `${scope}.legends.onlineMarketing`,
      defaultMessage: 'Online marketing targets',
    },
    reviews: {
      id: `${scope}.legends.reviews`,
      defaultMessage: 'Reviews',
    },
    permits: {
      id: `${scope}.legends.permits`,
      defaultMessage: 'Permits',
    },
    sales: {
      id: `${scope}.legends.sales`,
      defaultMessage: 'Sales',
    },
    royalties: {
      id: `${scope}.legends.royalties`,
      defaultMessage: 'Royalties',
    },
  },
})
